export function fmtEur(v, decimals = 0) {
  if (v === null || v === undefined || isNaN(v)) return "n.d.";
  return "€ " + Number(v).toLocaleString("it-IT", { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}

export function fmtNum(v, decimals = 0) {
  if (v === null || v === undefined || isNaN(v)) return "n.d.";
  return Number(v).toLocaleString("it-IT", { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}

export function fmtRatio(v, unit) {
  if (v === null || v === undefined || isNaN(v)) return "n.d.";
  if (unit === "EUR") return fmtEur(v);
  if (unit === "%") return fmtNum(v, 1) + "%";
  if (unit === "x") return fmtNum(v, 2) + "x";
  if (unit === "gg") return fmtNum(v, 0) + " gg";
  return fmtNum(v, 2);
}

export function fmtCompact(v) {
  if (v === null || v === undefined || isNaN(v)) return "n.d.";
  const abs = Math.abs(v);
  if (abs >= 1e6) return "€ " + (v / 1e6).toLocaleString("it-IT", { maximumFractionDigits: 2 }) + "M";
  if (abs >= 1e3) return "€ " + (v / 1e3).toLocaleString("it-IT", { maximumFractionDigits: 0 }) + "K";
  return fmtEur(v);
}

export const STATUS_META = {
  ottimo: { label: "Ottimo", cls: "text-emerald-500 border-emerald-500/40 bg-emerald-500/10" },
  adeguato: { label: "Adeguato", cls: "text-amber-500 border-amber-500/40 bg-amber-500/10" },
  critico: { label: "Critico", cls: "text-red-500 border-red-500/40 bg-red-500/10" },
  nd: { label: "N.D.", cls: "text-slate-400 border-slate-400/40 bg-slate-400/10" },
};

export const CATEGORY_META = {
  Liquidita: { label: "Indici di Liquidità" },
  Solidita: { label: "Indici di Solidità / Solvibilità" },
  Redditivita: { label: "Indici di Redditività" },
  Efficienza: { label: "Indici di Efficienza e Ciclo Circolante" },
  Crisi: { label: "Allerta Crisi d'Impresa (CNDCEC)" },
};

export const RATING_META = {
  A: { label: "Solido", text: "text-emerald-500", box: "border-emerald-500/40 bg-emerald-500/10" },
  B: { label: "Adeguato", text: "text-blue-500", box: "border-blue-500/40 bg-blue-500/10" },
  C: { label: "Debole", text: "text-amber-500", box: "border-amber-500/40 bg-amber-500/10" },
  D: { label: "Critico", text: "text-red-500", box: "border-red-500/40 bg-red-500/10" },
};
